import __ from "web/Layout/Translations";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import getDateTime from "web/utils/data/parser/dateAndTime/getDateTime";

import type { Nullable } from "web/types/Utils";

const getProductDate = (
  date: Nullable<string>,
  time: Nullable<string>,
  validDate?: Nullable<string>
) => {
  switch (true) {
    case Boolean(date): {
      return `${date ? `${__("Data")}: ${formatDate(date)}` : ""} ${
        time ? `${__("godz.")} ${time}` : ""
      }`;
    }
    case !!validDate: {
      return `${__("Ważny do")}: ${formatDate(validDate)}`;
    }
    default:
      return null;
  }
};

export const getProductDateDateTime = (
  date: Nullable<string>,
  time: Nullable<string>,
  validDate?: Nullable<string>
) => {
  switch (true) {
    case Boolean(date): {
      if (time) {
        return getDateTime(`${date} ${time}`, true);
      }
      return getDateTime(date);
    }
    case !!validDate: {
      return getDateTime(validDate);
    }
    default:
      return undefined;
  }
};

export default getProductDate;
